// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"02617fbd","114":"721da0e0","150":"43aa751c","248":"aac59d96","441":"199605b3","442":"beac1802","639":"76cd07ca","739":"3fae0fc4","870":"604c0ab4"}[chunkId] + ".chunk.js";
};